import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/age-gate-simple.module.scss';
import FieldLabel from '../fields/FieldLabel';

const propTypes = {
    setUnlocked: PropTypes.func,
    legalClassName: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    setUnlocked: null,
    legalClassName: null,
    className: null,
};

function AgeGateDefault({ setUnlocked, legalClassName, className }) {
    const themeClassName = useThemeClassName(styles);
    const [showAgeError, setShowAgeError] = useState(false);

    const onClickNo = useCallback(() => {
        setShowAgeError(true);
    }, [setShowAgeError]);

    const onClickYes = useCallback(() => {
        setUnlocked(true);
    }, [setUnlocked]);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className !== null,
                    [styles.showAgeError]: showAgeError,
                },
            ])}
        >
            <FieldLabel className={styles.label}>
                <FormattedMessage
                    defaultMessage="Are you 18 or over?"
                    description="Age gate label"
                />
            </FieldLabel>
            <div
                className={classNames([
                    styles.legal,
                    {
                        [legalClassName]: legalClassName !== null,
                    },
                ])}
            >
                <FormattedMessage
                    defaultMessage='By clicking on "Yes", you confirm that you are of legal age in Quebec to view the content of this site.'
                    description="Age gate legal"
                />
            </div>

            <div className={styles.ageError}>
                <FormattedMessage
                    defaultMessage="You must be of legal drinking age to enter"
                    description="Age gate error label"
                />
            </div>
            <div className={styles.buttons}>
                <StyledButton className={styles.button} colored onClick={onClickNo}>
                    <FormattedMessage defaultMessage="No" description="Button label" />
                </StyledButton>
                <StyledButton className={styles.button} colored onClick={onClickYes}>
                    <FormattedMessage defaultMessage="Yes" description="Button label" />
                </StyledButton>
            </div>
        </div>
    );
}

AgeGateDefault.propTypes = propTypes;
AgeGateDefault.defaultProps = defaultProps;

export default AgeGateDefault;
